export const PER_PAGE = 50
